import React, { useRef } from "react"

import { getNestedData } from "../../util/accessors"
import styles from "./styles"

import { Autocomplete, TextField } from "@mui/material"
import { Field } from "formik"

export default function _Autocomplete(props) {
	const { name, options, value, displayAccessor } = props
	const { onSearch, onInput, onSelect } = props

	const inputTimeout = useRef(() => null)

	async function handleInput(_, value) {
		if (inputTimeout?.current) {
			clearTimeout(inputTimeout?.current)
		}

		if (value) {
			inputTimeout.current = window.setTimeout(async () => {
				await onSearch(value)
			}, 100)
		}

		await onInput(value)
	}

	async function handleSelect(_, value) {
		await onSelect(value)
	}

	function handleOption(option) {
		if (typeof option === "object" && displayAccessor) {
			return getNestedData({ object: option, path: displayAccessor })
		} else {
			return option
		}
	}

	return (
		<Field name={name}>
			{({ field }) => (
				<>
					<Autocomplete
						{...field}
						freeSolo
						disableClearable
						disablePortal
						value={value || ""}
						inputValue={value || ""}
						options={options}
						getOptionLabel={handleOption}
						onChange={handleSelect}
						onInputChange={handleInput}
						renderInput={(props) => <TextField {...props} />}
						slotProps={{ listbox: { sx: styles.options } }}
						sx={styles.field}
					/>
				</>
			)}
		</Field>
	)
}
